import { locales, availableLocales, getUrls } from '@dfds-frontend/contentful-api-calls';
export { fetchTopNavigations, locales } from '@dfds-frontend/contentful-api-calls';
import { styled, theme, DefaultButtonStyles, Button, Link as Link$1, DefaultLinkStyle, GridItem, ExternalLink, darkerTheme, whiteTheme, config, Divider, Container, Grid, Text, ArrowRight, Close, Search, SupportContact, Account, ChevronDown, Menu, SvgDocument } from '@dfds-frontend/hydro';
export { breakpoints, config, css, darkerTheme, getCssText, globalCss, keyframes, styled, theme, whiteTheme } from '@dfds-frontend/hydro';
import { createContext, forwardRef, Children, Fragment, useState, useMemo, useContext, useRef, useEffect, useCallback, useLayoutEffect, createElement, cloneElement } from 'react';
import { jsxs, jsx, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { useStore } from '@nanostores/react';
import { atom, computed } from 'nanostores';
import { track } from '@dfds-frontend/tracking';
import { Accordion, AccordionButton, AccordionPanel, AccordionItem } from '@reach/accordion';
import { TR, SK, SE, RU, RO, PL, NO, NL, MA, LV, LT, KR, JP, IT, GB, FR, FI, ES, EE, DK, DE, CZ, CN, BR, BG, BE } from 'country-flag-icons/react/3x2';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure, useSearchBox, useHits, Highlight } from 'react-instantsearch';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var Themes = {
  WHITE: whiteTheme,
  LIGHT: whiteTheme,
  LIGHTER: whiteTheme,
  DARK: darkerTheme,
  DARKER: darkerTheme
};
var componentsObj = {};
var CustomComponentsContext = createContext({
  Components: componentsObj,
  addComponent: (_arg, key) => {
    componentsObj[key] = _arg;
  }
});
function CustomComponentWrapper(_a) {
  var _b = _a, {
    componentKey: componentKey3,
    defaultComponent: DefaultComponent,
    children
  } = _b, props = __objRest(_b, [
    "componentKey",
    "defaultComponent",
    "children"
  ]);
  const [components, setComponents] = useState(
    componentsObj
  );
  const contextValue = useMemo(
    () => ({
      Components: components,
      addComponent: (_args = DefaultComponent, key = componentKey3) => {
        componentsObj[key] = _args;
        setComponents((oldState) => __spreadProps(__spreadValues({}, oldState), {
          [key]: _args
        }));
      }
    }),
    [components, componentKey3, setComponents, DefaultComponent]
  );
  const component = contextValue.Components[componentKey3];
  return /* @__PURE__ */ jsx(CustomComponentsContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(DefaultComponent, __spreadProps(__spreadValues({ as: component }, props), { children })) });
}
var Image = styled("img", {
  objectFit: "cover",
  height: "100%",
  width: "100%"
});
var componentKey = "Image";
function useCustomImageComponent(ImageComponent) {
  const { addComponent } = useContext(CustomComponentsContext);
  useMemo(() => {
    addComponent(ImageComponent, componentKey);
  }, [ImageComponent, addComponent]);
}
function ImageWithContext(props) {
  return /* @__PURE__ */ jsx(
    CustomComponentWrapper,
    __spreadValues({
      defaultComponent: Image,
      componentKey
    }, props)
  );
}
var NO_BORDER_SPACING = "12px";
var buttonStyles = {
  variants: {
    variant: {
      panel: {
        "--colors-text": theme.colors["white-primary"],
        backgroundColor: "$blue-primary",
        paddingBlock: NO_BORDER_SPACING,
        border: "none",
        "&:after": {
          backgroundColor: "$text"
        }
      },
      navtab: {
        fontSize: NO_BORDER_SPACING,
        fontWeight: "$regular",
        padding: "6px $xs",
        margin: "0 $xxs",
        borderRadius: 0,
        borderWidth: "1px",
        "&:hover, &:focus, &:active": {
          borderColor: "$blue-primary",
          color: "$blue-primary"
        }
      },
      basic: {
        fontWeight: "$regular",
        border: "none",
        padding: "10px $xs",
        textAlign: "left",
        justifyContent: "flex-start",
        width: "fit-content",
        "img + svg": {
          display: "none"
        },
        "&:hover, &:focus, &:active": {
          "--colors-text": theme.colors["blue-primary"]
        }
      }
    }
  },
  defaultVariants: {
    variant: "outlined"
  }
};
var DefaultStyles = __spreadProps(__spreadValues({}, buttonStyles), {
  variants: {
    variant: __spreadProps(__spreadValues({}, buttonStyles.variants.variant), {
      text: DefaultButtonStyles.variants.variant.text,
      primary: DefaultButtonStyles.variants.variant.filled,
      secondary: DefaultButtonStyles.variants.variant.outlined
    })
  }
});
var StyledButton = styled(Button, DefaultStyles);
var currentLocaleStore = atom("en");
function useLocale() {
  return useStore(currentLocaleStore);
}
function useSetLocale(locale) {
  currentLocaleStore.set(locale.toLowerCase());
}
var componentKey2 = "Link";
var StyledNavLink = styled(Link$1, __spreadProps(__spreadValues({}, DefaultStyles), {
  variants: __spreadProps(__spreadValues(__spreadValues({}, DefaultLinkStyle.variants), DefaultStyles.variants), {
    variant: __spreadValues(__spreadValues({}, DefaultLinkStyle.variants.variant), DefaultStyles.variants.variant)
  }),
  defaultVariants: { variant: "basic" }
}));
function useCustomLinkComponent(LinkComponent) {
  const { addComponent } = useContext(CustomComponentsContext);
  useMemo(() => {
    addComponent(LinkComponent, componentKey2);
  }, [LinkComponent, addComponent]);
}
function useConstructHrefWithLocale(href) {
  const locale = useLocale();
  const firstPartOfHref = href == null ? void 0 : href.split("/")[(href == null ? void 0 : href.startsWith("/")) ? 1 : 0];
  if (!(href == null ? void 0 : href.startsWith("http")) && !(href == null ? void 0 : href.startsWith("mailto:")) && !(href == null ? void 0 : href.startsWith("tel:")) && firstPartOfHref && !availableLocales.has(firstPartOfHref.toLowerCase())) {
    return `/${locale}${(href == null ? void 0 : href.startsWith("/")) ? "" : "/"}${href}`;
  }
  return href;
}
function BaseLink(_a) {
  var _b = _a, { href } = _b, props = __objRest(_b, ["href"]);
  return /* @__PURE__ */ jsx(
    CustomComponentWrapper,
    __spreadValues({
      defaultComponent: StyledNavLink,
      componentKey: componentKey2,
      href: useConstructHrefWithLocale(href)
    }, props)
  );
}
function Link(_a) {
  var _b = _a, {
    link,
    children,
    variant,
    href
  } = _b, rest = __objRest(_b, [
    "link",
    "children",
    "variant",
    "href"
  ]);
  var _a2, _b2;
  const props = __spreadProps(__spreadValues({}, rest), {
    href: href || ((_a2 = link == null ? void 0 : link.url) == null ? void 0 : _a2.url),
    variant: variant || (link == null ? void 0 : link.linkType)
  });
  if (!(props == null ? void 0 : props.href)) return null;
  if (link == null ? void 0 : link.openInNewWindow) props.target = "_blank";
  const isExternalLink = ((_b2 = link == null ? void 0 : link.url) == null ? void 0 : _b2.urlType) === "External";
  return /* @__PURE__ */ jsxs(BaseLink, __spreadProps(__spreadValues({}, props), { children: [
    children || (link == null ? void 0 : link.displayText),
    isExternalLink && /* @__PURE__ */ jsx(ExternalLink, {})
  ] }));
}
var currentBusinessUnitStore = atom(null);
function useBusinessUnit() {
  return useStore(currentBusinessUnitStore);
}
function setBusinessUnit(businessUnit) {
  currentBusinessUnitStore.set(businessUnit);
}

// src/stores/navigation.ts
var currentNavigationStore = atom(null);
function useNavigation(options) {
  return useStore(useSelectedNavigationItem, options);
}
function setNavigations(navigation) {
  currentNavigationStore.set(navigation);
}
var useSelectedNavigationItem = computed(
  [currentNavigationStore, currentBusinessUnitStore],
  (currentNavigation, currentBusinessUnit) => {
    var _a, _b;
    const businessUnit = currentBusinessUnit == null ? void 0 : currentBusinessUnit.toUpperCase();
    return (_b = (_a = currentNavigation == null ? void 0 : currentNavigation.items.find(
      (navigation) => {
        var _a2;
        return businessUnit === ((_a2 = navigation == null ? void 0 : navigation.businessArea) == null ? void 0 : _a2.toUpperCase());
      }
    )) != null ? _a : currentNavigation == null ? void 0 : currentNavigation.items.find(
      (navigation) => {
        var _a2;
        return (_a2 = navigation == null ? void 0 : navigation.businessArea) == null ? void 0 : _a2.toLowerCase().includes("freight");
      }
    )) != null ? _b : {};
  }
);
var BaseLinkStyled = styled(BaseLink, {});
var Logo = (_a) => {
  var _b = _a, { logoUrl } = _b, props = __objRest(_b, ["logoUrl"]);
  var _a2, _b2;
  const locale = useLocale();
  const { landingPage } = useNavigation({ keys: ["landingPage"] });
  return /* @__PURE__ */ jsx(
    BaseLinkStyled,
    {
      "data-e2e": "Logo",
      href: `/${locale}/${(_b2 = (_a2 = landingPage == null ? void 0 : landingPage.url) == null ? void 0 : _a2.url) != null ? _b2 : ""}`,
      css: {
        alignSelf: "center",
        padding: 0,
        width: "fit-content",
        zIndex: 10
      },
      children: /* @__PURE__ */ jsx(
        "img",
        __spreadValues({
          src: logoUrl,
          height: props.height,
          width: props.width || "auto",
          alt: "DFDS logo"
        }, props)
      )
    }
  );
};

// src/typeguards/link.ts
function navItemIsLink(item) {
  var _a;
  return !!item && !((_a = item.sectionItemsCollection || item.navigationSectionsCollection) == null ? void 0 : _a.items);
}
var isDarkenTheme = (themeName) => {
  if (!themeName) return false;
  return ["DARK", "DARKER"].includes(themeName);
};
var isDefinedTheme = (themeName) => !!themeName && Object.keys(Themes).includes(themeName);
function getThemeColors(sectionTheme) {
  const theme2 = Themes[sectionTheme == null ? void 0 : sectionTheme.themeName];
  const backgroundTheme = (sectionTheme == null ? void 0 : sectionTheme.themeBackgroundColor) || theme2.colors.background.value;
  const colors = config.theme.colors;
  const backgroundColor = colors[backgroundTheme];
  return { theme: theme2, backgroundColor };
}

// src/components/Navigation/FooterNavigation/FooterNavigation.styles.ts
var StyledFooter = styled("footer", {
  position: "relative",
  bottom: 0,
  color: "$text"
});
var FooterWrapper = styled("div", {
  paddingBlock: "$m",
  background: "$background"
});
var FooterSectionsWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  marginBlock: "$s",
  "@mUp": {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    margin: "auto"
  }
});
var FooterLinksSection = styled("div", {
  display: "flex",
  flexDirection: "column",
  marginBottom: "$s",
  p: {
    marginTop: 0,
    padding: "$xs"
  },
  "@mUp": {
    margin: 0
  }
});
var IconWrapper = styled("span", {
  display: "flex",
  flexShrink: 0,
  boxSizing: "border-box",
  height: "$m",
  width: "$m",
  marginLeft: "$xs",
  img: {
    margin: "auto",
    width: "1.5rem",
    height: "auto"
  }
});
var SocialSection = styled("div", {
  display: "inline-grid",
  gridAutoFlow: "column",
  alignItems: "center",
  marginBlock: "$s",
  gap: "$s",
  p: {
    margin: 0
  },
  "@mUp": {
    margin: "auto"
  }
});
var StyledIconWrapper = styled("div", {
  display: "grid",
  gridAutoFlow: "column",
  img: {
    width: "1.25rem",
    height: "auto"
  }
});
var StyledLegalSection = styled("div", {
  display: "inline-grid",
  marginBlock: "$s",
  gap: "$m",
  "@mUp": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
  }
});
var StyledLegalLinks = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  a: {
    flexShrink: 0,
    color: "$text",
    padding: "$xs $s $xs 0"
  },
  "@mUp": {
    flexDirection: "row",
    paddingBlock: 0
  }
});
function LegalSection({
  legalSection,
  logoUrl
}) {
  return /* @__PURE__ */ jsx(GridItem, { children: /* @__PURE__ */ jsxs(StyledLegalSection, { children: [
    /* @__PURE__ */ jsx(Logo, { height: "32px", logoUrl }),
    /* @__PURE__ */ jsx(StyledLegalLinks, { children: legalSection == null ? void 0 : legalSection.map((link) => {
      return /* @__PURE__ */ jsx(
        Link,
        {
          "data-e2e": "footer-legal-section-item",
          link
        },
        link == null ? void 0 : link.sys.id
      );
    }) })
  ] }) });
}
function IconImage({ icon }) {
  if (!((icon == null ? void 0 : icon.url) && icon.width && icon.height && icon.title)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    ImageWithContext,
    {
      src: icon.url,
      width: icon.width,
      height: icon.height,
      alt: icon.title
    }
  );
}
function FooterChildren({ footerData, useSmallVariant }) {
  var _a, _b, _c, _d, _e, _f;
  const columnsCollection = (_a = footerData == null ? void 0 : footerData.columnsCollection) == null ? void 0 : _a.items;
  const appLink = footerData == null ? void 0 : footerData.appLink;
  const socialSection = footerData == null ? void 0 : footerData.socialSection;
  const logoURL = ((_c = (_b = footerData == null ? void 0 : footerData.siteSettings) == null ? void 0 : _b.logo) == null ? void 0 : _c.url) || "";
  const legalSection = (_e = (_d = footerData == null ? void 0 : footerData.legalSection) == null ? void 0 : _d.sectionItemsCollection) == null ? void 0 : _e.items;
  const allowedsectionItemsCollectionTypenames = ["Link", "contentful_t_Link"];
  if (useSmallVariant)
    return /* @__PURE__ */ jsx(LegalSection, { legalSection, logoUrl: logoURL });
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(GridItem, { children: /* @__PURE__ */ jsx(FooterSectionsWrapper, { children: columnsCollection == null ? void 0 : columnsCollection.map((section) => {
      var _a2, _b2;
      return /* @__PURE__ */ jsxs(FooterLinksSection, { children: [
        /* @__PURE__ */ jsx(Text, { variant: "body-1-bold", children: section == null ? void 0 : section.displayText }),
        (_b2 = section == null ? void 0 : section.sectionItemsCollection) == null ? void 0 : _b2.items.map((link) => {
          var _a3, _b3, _c2;
          if (!((_a3 = link == null ? void 0 : link.sys) == null ? void 0 : _a3.id) || !(link == null ? void 0 : link.__typename) || !allowedsectionItemsCollectionTypenames.includes(
            link.__typename
          )) {
            console.error(
              `__typename ${link == null ? void 0 : link.__typename} is not allowed in the footer, only ${allowedsectionItemsCollectionTypenames.join(
                ","
              )}. Found in the section id ${(_b3 = section.sys) == null ? void 0 : _b3.id}`
            );
            return /* @__PURE__ */ jsx(Fragment$1, {});
          }
          return /* @__PURE__ */ jsx(
            Link,
            {
              link,
              "data-e2e": "footer-link"
            },
            `footer-${(_c2 = section == null ? void 0 : section.sys) == null ? void 0 : _c2.id}-${link == null ? void 0 : link.sys.id}`
          );
        })
      ] }, ((_a2 = section == null ? void 0 : section.sys) == null ? void 0 : _a2.id) || (section == null ? void 0 : section.entryTitle));
    }) }) }),
    appLink && /* @__PURE__ */ jsx(GridItem, { children: /* @__PURE__ */ jsxs(
      Link,
      {
        "data-e2e": "footer-app-link",
        link: appLink,
        variant: "outlined",
        fullwidth: true,
        children: [
          /* @__PURE__ */ jsx(IconWrapper, { children: /* @__PURE__ */ jsx(IconImage, { icon: appLink.icon }) }),
          appLink.displayText
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(GridItem, { large: 6, children: /* @__PURE__ */ jsxs(SocialSection, { children: [
      /* @__PURE__ */ jsx(Text, { variant: "body-1-bold", children: socialSection == null ? void 0 : socialSection.displayText }),
      /* @__PURE__ */ jsx(StyledIconWrapper, { children: (_f = socialSection == null ? void 0 : socialSection.sectionItemsCollection) == null ? void 0 : _f.items.map((socialItem) => {
        var _a2, _b2;
        if (!navItemIsLink(socialItem)) return /* @__PURE__ */ jsx(Fragment$1, {});
        return !!(socialItem == null ? void 0 : socialItem.url) && /* @__PURE__ */ jsx(
          Link,
          {
            "data-e2e": "footer-social-link",
            link: socialItem,
            "aria-label": `${((_b2 = socialItem.icon) == null ? void 0 : _b2.title) || "Social media link"}`,
            children: /* @__PURE__ */ jsx(IconImage, { icon: socialItem.icon })
          },
          ((_a2 = socialItem == null ? void 0 : socialItem.sys) == null ? void 0 : _a2.id) || (socialItem == null ? void 0 : socialItem.entryTitle)
        );
      }) })
    ] }) }),
    /* @__PURE__ */ jsx(GridItem, { children: /* @__PURE__ */ jsx(Divider, {}) }),
    /* @__PURE__ */ jsx(LegalSection, { legalSection, logoUrl: logoURL })
  ] });
}
function FooterNavigation(props) {
  return /* @__PURE__ */ jsxs(StyledFooter, { id: "footer", children: [
    /* @__PURE__ */ jsx(Divider, {}),
    /* @__PURE__ */ jsx(FooterWrapper, { children: /* @__PURE__ */ jsx(Container, { children: /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(FooterChildren, __spreadValues({}, props)) }) }) })
  ] });
}
function trackGlobalMenuClick(navigationTitle = "", navigationTitleContentfulId = "") {
  trackMenuClick(
    "globalMenuClicked",
    navigationTitle,
    navigationTitleContentfulId
  );
}
function trackContextualMenuClick(navigationTitle = "", navigationTitleContentfulId = "") {
  trackMenuClick("topMenuClicked", navigationTitle, navigationTitleContentfulId);
}
function trackAccordionClick(navigationTitle = "", navigationTitleContentfulId = "") {
  trackMenuClick("accordionClick", navigationTitle, navigationTitleContentfulId);
}
var trackMenuClick = (event, navigationTitle, navigationTitleContentfulId) => {
  if (!navigationTitle || !navigationTitleContentfulId) return;
  track({
    event,
    navigationTitle,
    navigationTitleContentfulId
  });
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

// src/hooks/useResponsiveNav.tsx
function useResponsiveNav(ref) {
  const [isMobile, setIsMobile] = useState(false);
  const layout = useCallback(() => {
    if (!ref.current) return null;
    const fullWidth = ref.current.getBoundingClientRect().width;
    let centerWidth = 0;
    const centerChildNodes = ref.current.childNodes[1].childNodes;
    centerChildNodes.forEach((n) => {
      centerWidth += n.clientWidth;
    });
    const widths = {
      leftWidth: ref.current.childNodes[0].getBoundingClientRect().width,
      centerWidth,
      rightWidth: ref.current.childNodes[2].getBoundingClientRect().width
    };
    setIsMobile(
      fullWidth < widths.centerWidth + Math.max(widths.leftWidth, widths.rightWidth) * 2 + 64
    );
  }, [ref]);
  useIsomorphicLayoutEffect(() => {
    layout();
    window.addEventListener("resize", layout);
    return () => {
      window.removeEventListener("resize", layout);
    };
  }, [layout]);
  return [isMobile];
}
function useCallbackOnRouteChange(callback) {
  const body = typeof document != "undefined" && document.querySelector("body");
  const currentUrl = useRef(
    typeof document != "undefined" && document.location.href
  );
  useEffect(() => {
    if (!body) return;
    const observer = new MutationObserver(() => {
      if (currentUrl.current === document.location.href) return;
      currentUrl.current = document.location.href;
      callback();
    });
    observer.observe(body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [callback, body]);
}
var useClickOutside = (ref, handler, passive = true) => {
  useEffect(() => {
    function listener(event) {
      if (!handler || !ref.current || ref.current.contains(event.target))
        return;
      handler();
    }
    document.addEventListener("mousedown", listener, { passive });
    document.addEventListener("touchstart", listener, { passive });
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, passive]);
};
var Button2 = (_a) => {
  var _b = _a, { icon: Icon2, children } = _b, rest = __objRest(_b, ["icon", "children"]);
  return /* @__PURE__ */ jsxs(StyledButton, __spreadProps(__spreadValues({}, rest), { children: [
    Icon2 && /* @__PURE__ */ jsx(Icon2, {}),
    children
  ] }));
};
var MENU_MAX_WIDTH = "400px";
var BUTTON_SIZE = "2.75rem";
var ITEM_HEIGHT = "4rem";
var GlobalNavigationStyled = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 2.5rem",
  height: "3.25rem",
  backgroundColor: "$background",
  position: "relative"
});
var BuContainerStyled = styled("div", {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  alignItems: "center",
  "& button:not(:first-of-type)": {
    marginLeft: "$xxs"
  }
});
var StyledSearchAndHelpSection = styled("div", {
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flexDirection: "row-reverse",
  minWidth: "150px",
  "@lUp": {
    justifyContent: "flex-end",
    flexDirection: "row"
  },
  variants: {
    forceMobile: {
      true: {
        "@lUp": {
          justifyContent: "flex-start",
          flexDirection: "row-reverse"
        }
      }
    }
  },
  svg: {
    fontSize: "$headline3",
    "@xlUp": {
      fontSize: "$headline4"
    }
  }
});
var HideOnMobile = styled("div", {
  display: "none",
  "@lUp": {
    display: "unset"
  },
  variants: {
    forceHide: {
      true: {
        "@lUp": {
          display: "none"
        }
      }
    }
  }
});
var HideOnDesktop = styled("div", {
  "@lUp": {
    display: "none"
  },
  variants: {
    forceShow: {
      true: {
        "@lUp": {
          display: "initial"
        }
      }
    }
  }
});
var StyledContactAndPortals = styled("div", {
  height: "100%",
  position: "relative",
  button: {
    height: "100%"
  }
});
var StyledContextualNavigationLinksContainer = styled("div", {
  visibility: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  "@lUp": {
    display: "flex",
    visibility: "visible"
  },
  variants: {
    forceHide: {
      true: {
        "@lUp": {
          visibility: "hidden"
        }
      }
    }
  },
  "> a, > div, button": {
    whiteSpace: "nowrap",
    fontWeight: "$bold",
    height: "100%"
  }
});
styled("div", {
  borderLeft: theme.borderStyles.secondary,
  height: "1.5rem",
  margin: "auto $xs"
});
var ParentWithRelativePosition = styled(
  "div",
  {
    position: "relative"
  }
);
var StyledContextualNavigation = styled(
  "div",
  {
    backgroundColor: "$background",
    display: "flex",
    height: ITEM_HEIGHT,
    justifyContent: "space-between",
    padding: "0 $s",
    position: "relative",
    zIndex: 140,
    borderBottom: theme.borderStyles.primary,
    "@mUp": {
      padding: "0 $xs"
    }
  }
);
var StyledDrawer = styled("div", {
  backgroundColor: "$background",
  color: "$text",
  transition: "box-shadow 300ms",
  display: "flex",
  flexDirection: "column",
  position: "fixed",
  top: "63px",
  bottom: 0,
  overflow: "scroll",
  right: 0,
  width: "100%",
  height: "calc(100% + 2px)",
  maxWidth: MENU_MAX_WIDTH,
  paddingBottom: "2rem",
  webkitOverflowScrolling: "touch",
  a: {
    padding: "$s",
    width: "100%"
  },
  "a, button": {
    color: "$groupBluePrimary",
    borderRadius: 0,
    width: "100%",
    "&:hover": {
      color: "$bluePrimary"
    }
  }
});
var StyledCurrentBusinessUnit = styled("div", {
  order: -1,
  "> div": {
    "> a, button": {
      fontWeight: "$bold",
      borderBottom: theme.borderStyles.primary
    }
  }
});
var StyledIconButton = styled(Button2, {
  color: "$group-blue-primary!important",
  fontSize: "1.5rem!important",
  // don't use theme props
  minWidth: BUTTON_SIZE,
  minHeight: BUTTON_SIZE,
  position: "relative",
  "&::after": {
    content: "",
    display: "block",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    position: "absolute",
    background: "$blue-primary",
    opacity: 0
  },
  "&:hover": {
    "&::after": {
      opacity: 0.08
    }
  }
});
var StyledChildrenAndLocalePickerSection = styled("div", {
  display: "flex"
});
styled(
  "div",
  {
    borderBottom: theme.borderStyles.primary,
    paddingLeft: "$s",
    position: "fixed",
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "$background",
    height: ITEM_HEIGHT,
    width: "100%",
    maxWidth: MENU_MAX_WIDTH,
    zIndex: 1,
    button: {
      width: "auto"
    }
  }
);
var StyledNestedNavigationLevel = styled(Accordion, {
  "a, button": {
    padding: "$s",
    borderRadius: 0
  }
});
var StyledAccordionButton = styled(AccordionButton, {
  display: "flex",
  justifyContent: "space-between",
  color: "$text",
  padding: "$s",
  appearance: "none",
  background: "none",
  cursor: "pointer",
  border: "none",
  width: "100%",
  svg: {
    transition: "transform 300ms"
  },
  "&:hover": {
    color: "$blue-primary"
  },
  '&[data-state="open"]': {
    border: "none"
  },
  '&[data-state="open"] > svg': {
    transform: "rotate(180deg)"
  },
  'div[role="region"][data-state="open"] &': {
    paddingLeft: "$xs"
  }
});
var StyledAccordionPanel = styled(AccordionPanel, {
  paddingLeft: "$s",
  'a, div[role="region"][data-state="open"]': {
    marginLeft: "-$xs",
    borderBottom: "0"
  }
});
var LeftSection = styled("div", {
  display: "flex",
  width: "fit-content"
});
var ChevronToggle = ({ isActive }) => /* @__PURE__ */ jsx(
  ChevronDown,
  {
    style: {
      transform: isActive ? "rotate(180deg)" : "none",
      transition: "transform 0.3s ease"
    }
  }
);
var NavButton = ({
  children,
  leadingIcon,
  trailingIcon,
  onClick,
  link,
  ariaLabel,
  isActiveDropdown
}) => {
  if (link) {
    return /* @__PURE__ */ jsx(
      Link,
      {
        "data-e2e": "navigation-link",
        "aria-label": ariaLabel,
        fullwidth: true,
        onClick,
        link
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Button2,
    {
      "data-e2e": "navigation-button",
      "aria-label": ariaLabel,
      variant: "basic",
      icon: leadingIcon,
      onClick,
      children: [
        /* @__PURE__ */ jsx("span", { children }),
        !!trailingIcon && /* @__PURE__ */ jsx(ChevronToggle, { isActive: isActiveDropdown })
      ]
    }
  );
};
var StyledMegaMenu = styled("div", {
  display: "flex",
  flexDirection: "column",
  a: {
    padding: "$xs"
  }
});
var MegaMenu = (props) => {
  var _a;
  return /* @__PURE__ */ jsx(Fragment$1, { children: (_a = props == null ? void 0 : props.items) == null ? void 0 : _a.map((item) => {
    var _a2, _b;
    return /* @__PURE__ */ jsxs(StyledMegaMenu, { children: [
      /* @__PURE__ */ jsx(Text, { variant: "action", children: item == null ? void 0 : item.displayText }),
      (_b = (_a2 = item == null ? void 0 : item.sectionItemsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b.map(
        (navItem) => {
          var _a3;
          return !!navItem && /* @__PURE__ */ jsx(
            NavButton,
            {
              link: navItem
            },
            (_a3 = navItem == null ? void 0 : navItem.sys) == null ? void 0 : _a3.id
          );
        }
      )
    ] }, `mega-menu-${item == null ? void 0 : item.displayText}`);
  }) });
};
var StyledLinkDropdown = styled("div", {
  alignItems: "flex-start",
  flexDirection: "column",
  position: "absolute",
  minWidth: "190px",
  backgroundColor: "$background",
  zIndex: 10,
  display: "none",
  padding: "$xs 0",
  borderTop: `1px solid $group-blue-15`,
  boxShadow: "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 0 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  a: {
    width: "100%",
    padding: `$xs $s`,
    fontWeight: 400
  },
  variants: {
    isMegaMenu: {
      true: {
        flexDirection: "row",
        width: "100%",
        left: 0,
        right: 0,
        padding: "$m 0"
      }
    },
    alignRight: {
      true: {
        right: 0,
        marginTop: "13px"
      }
    },
    open: {
      true: {
        display: "flex",
        justifyContent: "space-evenly"
      }
    }
  }
});
function navItemHasSections(items) {
  return items.some((item) => !item.sectionItemsCollection);
}
var LinkDropdown = ({
  items,
  alignRight,
  open
}) => {
  if (!items) return null;
  const megaMenu = !navItemHasSections(items);
  return /* @__PURE__ */ jsx(
    StyledLinkDropdown,
    {
      "data-e2e": "contextual-dropdown-button",
      open,
      alignRight,
      isMegaMenu: megaMenu,
      children: megaMenu ? /* @__PURE__ */ jsx(MegaMenu, { "data-e2e": "contextual-mega-menu", items }) : items.map((item) => {
        var _a;
        return /* @__PURE__ */ jsx(
          Link,
          {
            "data-e2e": "contextual-dropdown-link",
            link: item
          },
          (_a = item == null ? void 0 : item.sys) == null ? void 0 : _a.id
        );
      })
    }
  );
};
function isNavigationItem(item) {
  return !!(item == null ? void 0 : item.sectionItemsCollection);
}
function DesktopContextualNavigationItems({ forceHide = false }) {
  var _a;
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { navigationSectionsCollection: sectionItemsCollection } = useNavigation({
    keys: ["navigationSectionsCollection"]
  });
  const ref = useRef(null);
  const closeDropDown = useCallback(
    () => setActiveDropdown(null),
    [setActiveDropdown]
  );
  useClickOutside(ref, closeDropDown);
  useCallbackOnRouteChange(closeDropDown);
  return /* @__PURE__ */ jsx(
    StyledContextualNavigationLinksContainer,
    {
      forceHide,
      "data-e2e": "contextual-navigation",
      ref,
      children: (_a = sectionItemsCollection == null ? void 0 : sectionItemsCollection.items) == null ? void 0 : _a.map(
        (item, index) => {
          var _a2;
          return item && (!isNavigationItem(item) ? /* @__PURE__ */ jsx(
            NavButton,
            {
              "data-e2e": "contextual-link",
              link: item
            },
            item == null ? void 0 : item.displayText
          ) : /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx(
              NavButton,
              {
                isActiveDropdown: activeDropdown === index,
                "data-e2e": "contextual-dropdown-button",
                onClick: () => {
                  setActiveDropdown((currentIndex) => {
                    if (index === currentIndex) return null;
                    trackContextualMenuClick(
                      item.displayText,
                      item.sys.id
                    );
                    return index;
                  });
                },
                trailingIcon: /* @__PURE__ */ jsx(ChevronToggle, { isActive: activeDropdown === index }),
                children: item == null ? void 0 : item.displayText
              }
            ),
            /* @__PURE__ */ jsx(
              LinkDropdown,
              {
                items: (_a2 = item == null ? void 0 : item.sectionItemsCollection) == null ? void 0 : _a2.items,
                open: activeDropdown === index
              }
            )
          ] }, item == null ? void 0 : item.displayText));
        }
      )
    }
  );
}
function NestedNavigationLevel({
  items
}) {
  if (!items) return null;
  return /* @__PURE__ */ jsx(StyledNestedNavigationLevel, { collapsible: true, children: items.map((item) => {
    var _a;
    return /* @__PURE__ */ jsx(
      MenuListButton,
      {
        item
      },
      ((_a = item == null ? void 0 : item.sys) == null ? void 0 : _a.id) || (item == null ? void 0 : item.entryTitle)
    );
  }) });
}
function isTopLevel(item) {
  return !!(item == null ? void 0 : item.navigationSectionsCollection);
}
function MenuListButton({
  item,
  onClick
}) {
  var _a, _b;
  const { entryTitle } = useNavigation({ keys: ["entryTitle"] });
  if (!item) return null;
  const isNavigationFirstLevel = isTopLevel(item);
  const isOtherBusinessUnit = isNavigationFirstLevel && !!(entryTitle !== (item == null ? void 0 : item.entryTitle) && (item == null ? void 0 : item.landingPage));
  if (navItemIsLink(item) || isOtherBusinessUnit) {
    let link = item;
    let trackingFunction = trackContextualMenuClick;
    if (isOtherBusinessUnit) {
      trackingFunction = trackGlobalMenuClick;
      link = __spreadValues({
        displayText: item == null ? void 0 : item.displayText
      }, (item == null ? void 0 : item.landingPage) || {});
    }
    return /* @__PURE__ */ jsx(
      NavButton,
      {
        onClick: () => trackingFunction(link.entryTitle, link.sys.id),
        link
      }
    );
  }
  const childSection = isNavigationFirstLevel ? (_a = item.navigationSectionsCollection) == null ? void 0 : _a.items : (_b = item.sectionItemsCollection) == null ? void 0 : _b.items;
  if (isNavigationFirstLevel && childSection) {
    return /* @__PURE__ */ jsxs(StyledCurrentBusinessUnit, { children: [
      /* @__PURE__ */ jsx(Text, { variant: "subtitle-1", css: { padding: "$s" }, children: item == null ? void 0 : item.displayText }),
      /* @__PURE__ */ jsx(NestedNavigationLevel, { items: childSection })
    ] });
  }
  return /* @__PURE__ */ jsxs(AccordionItem, { children: [
    /* @__PURE__ */ jsxs(
      StyledAccordionButton,
      {
        onClick: (e) => {
          if (e.currentTarget.dataset.state !== "open")
            trackAccordionClick(
              item == null ? void 0 : item.entryTitle,
              item == null ? void 0 : item.sys.id
            );
          onClick == null ? void 0 : onClick(item);
        },
        children: [
          /* @__PURE__ */ jsx(Text, { as: "p", variant: "label-medium-bold", children: item == null ? void 0 : item.displayText }),
          /* @__PURE__ */ jsx(ChevronDown, { "aria-hidden": true })
        ]
      }
    ),
    /* @__PURE__ */ jsx(StyledAccordionPanel, { children: /* @__PURE__ */ jsx(NestedNavigationLevel, { items: childSection }) })
  ] });
}
function DesktopOnlyGlobalNavigation(_a) {
  var _b = _a, {
    children,
    forceHide
  } = _b, rest = __objRest(_b, [
    "children",
    "forceHide"
  ]);
  return /* @__PURE__ */ jsx(HideOnMobile, { forceHide, children: /* @__PURE__ */ jsx(GlobalNavigationStyled, __spreadProps(__spreadValues({}, rest), { className: Themes.DARKER, children: /* @__PURE__ */ jsx(BuContainerStyled, { children }) })) });
}
var useDisableHtmlScroll = (disable) => {
  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflow = disable ? "hidden" : "";
      return () => {
        html.style.overflow = "";
      };
    }
  }, [disable]);
};

// src/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  BE: () => BE,
  BG: () => BG,
  BR: () => BR,
  CN: () => CN,
  CZ: () => CZ,
  DE: () => DE,
  DK: () => DK,
  EE: () => EE,
  ES: () => ES,
  FI: () => FI,
  FR: () => FR,
  GB: () => GB,
  INT: () => FlagInt,
  IT: () => IT,
  JP: () => JP,
  KR: () => KR,
  LT: () => LT,
  LV: () => LV,
  MA: () => MA,
  NL: () => NL,
  NO: () => NO,
  PL: () => PL,
  RO: () => RO,
  RU: () => RU,
  SE: () => SE,
  SK: () => SK,
  TR: () => TR
});
var FlagInt = forwardRef(
  (props, svgRef) => /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "25px",
      height: "20px",
      viewBox: "0 0 25 20",
      fill: "none",
      ref: svgRef
    }, props), {
      children: [
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h25v20H0z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6 16.105c.235-.388.433-.796.59-1.22.275.12.543.258.8.41a6.625 6.625 0 0 1-1.4.81h.01zm-5.66-1.22c.158.424.356.832.59 1.22a6.203 6.203 0 0 1-1.42-.81c.264-.153.538-.29.82-.41h.01zm3.11 1.71c-.59 0-1.33-.8-1.88-2.19a7.418 7.418 0 0 1 1.88-.27 7.38 7.38 0 0 1 1.88.27c-.54 1.41-1.28 2.21-1.88 2.21v-.02zm3.54-3c.244-.959.386-1.941.42-2.93h2.6a6.659 6.659 0 0 1-1.63 3.72 8.327 8.327 0 0 0-1.39-.79zm-3.53-.77a8.735 8.735 0 0 0-2.28.31 12.68 12.68 0 0 1-.33-2.47h5.23a13.519 13.519 0 0 1-.33 2.47 8.806 8.806 0 0 0-2.3-.31h.01zm-3.95-2.16c.035.989.176 1.971.42 2.93a8.281 8.281 0 0 0-1.42.79 6.582 6.582 0 0 1-1.61-3.72h2.61zm6.6-1.35H9.44c.031-.76.128-1.516.29-2.26a8.585 8.585 0 0 0 4.65 0c.159.751.256 1.513.29 2.28l.04-.02zm1.34 0a14.809 14.809 0 0 0-.38-2.78c.507-.224.99-.499 1.44-.82a6.521 6.521 0 0 1 1.5 3.62l-2.56-.02zm-7.57-2.76c-.216.912-.34 1.843-.37 2.78H5.5a6.516 6.516 0 0 1 1.55-3.62c.447.327.926.609 1.43.84zm.4-1.31a6.336 6.336 0 0 1-.86-.46 6.488 6.488 0 0 1 1.5-.9 7.775 7.775 0 0 0-.64 1.36zm6.39-.02a8.557 8.557 0 0 0-.64-1.36 6.696 6.696 0 0 1 1.49.9 7.067 7.067 0 0 1-.89.48l.04-.02zm-1.24.47a6.99 6.99 0 0 1-1.98.36 6.995 6.995 0 0 1-1.94-.34c.55-1.47 1.32-2.34 1.93-2.34.61 0 1.4.87 1.95 2.34l.04-.02zm5.97 4.3A8 8 0 0 0 11.995 2a8 8 0 1 0 5.115 14.155l.09-.09a7.927 7.927 0 0 0 2.8-6.07z",
            fill: "#49A2DF"
          }
        )
      ]
    })
  )
);
FlagInt.displayName = "FlagInt";

// src/components/Navigation/TopNavigation/components/localeSelector/modal.style.ts
var Wrapper = styled("div", {
  display: "none",
  variants: {
    isOpen: {
      true: {
        display: "unset"
      }
    }
  }
});
var StyledModal = styled("div", {
  width: "100%",
  height: "100%",
  maxHeight: "100%",
  position: "fixed",
  zIndex: 9001,
  top: 0,
  left: "2vw",
  overflow: "auto",
  borderRadius: "$xs",
  "@mUp": {
    overflow: "auto",
    width: "90%",
    height: "fit-content",
    minWidth: "560px",
    margin: "auto",
    inset: 0
  },
  "@lUp": {
    maxWidth: "860px"
  }
});
var Overlay = styled("div", {
  overflow: "auto scroll",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 300,
  background: "rgba(0, 0, 0, 0.5)"
});
var ModalWrapper = styled("div", {
  zIindex: 100,
  background: "$background",
  margin: "auto",
  paddingBottom: "$l",
  "@mUp": {
    top: 0,
    paddingBottom: 0
  },
  "@lUp": {
    top: "10%"
  }
});
var HeaderWrapper = styled("div", {
  position: "sticky",
  top: 0,
  background: "$background",
  zIndex: 400
});
var Header = styled("div", {
  borderRadius: "$xs $xs 0 0",
  display: "flex",
  justifyContent: "space-between",
  padding: "$xs $s",
  alignItems: "center",
  "> * ": {
    marginBottom: 0
  },
  button: {
    fontSize: "$headline3"
  }
});
var Content = styled("div", {
  transform: "translateY(0px)",
  padding: "$xs",
  columnCount: 1,
  a: {
    width: "100%",
    padding: "14px"
  },
  "@mUp": {
    columnCount: 2
  },
  "@lUp": {
    columnCount: 3
  }
});
styled(Link, {});
var boxShadow = "0px 0px 1px 1px rgba(0,0,0,0.2)";
var Flag = styled("div", {
  width: "25px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "& svg": {
    "-webkit-box-shadow:": boxShadow,
    "-moz-box-shadow": boxShadow,
    "box-shadow": boxShadow
  }
});
var Language = styled("div", {
  fontSize: "$body"
});

// src/utils/routeLogic.ts
var pagesForNext = [
  "/en/freight-ferries-and-logistics",
  "/en-gb/freight-ferries-and-logistics",
  "/bg-bg/tovarni-feriboti-i-logistika",
  "/cs-cz/nakladni-trajekty-a-logistika",
  "/da-dk/fragt-faerger-og-logistik",
  "/de-de/fracht-faehren-und-logistik",
  "/es-es/carga-transporte-y-logistica",
  "/et-ee/kaubavedu-parvlaevad-ja-logistika",
  "/fi-fi/rahtilautat-ja-logistiikka",
  "/fr-fr/ferries-fret-et-logistique",
  "/fr-be/ferries-fret-et-logistique",
  "/fr-ma/ferries-fret-et-logistique",
  "/it-it/traghetti-merci-e-logistica",
  "/lv-lv/kravas-pramji-un-logistika",
  "/lt-lt/kroviniu-gabenimas-ir-logistika",
  "/nb-no/frakt-ferger-og-logistikk",
  "/nl-nl/vrachtvervoer-en-logistiek",
  "/nl-be/vrachtvervoer-en-logistiek",
  "/pl-pl/promy-towarowe-i-logistyka",
  "/ro-ro/feriboturi-de-transport-marfa-si-logistica",
  "/ru-ru/gruzovye-paromy-i-logistika",
  "/sk-sk/nakladna-doprava-a-logistika",
  "/sv-se/fraktfarjor-och-logistik",
  "/tr-tr/tasimacilik-feribot-ve-lojistik",
  "/en/about/careers",
  "/bg-bg/search",
  "/cs-cz/hledat",
  "/da-dk/soeg",
  "/de-de/suche",
  "/en/search",
  "/es-es/buscar",
  "/et-ee/otsi",
  "/fi-fi/hae",
  "/fr-fr/rechercher",
  "/fr-be/rechercher",
  "/it-it/cerca",
  "/lt-lt/ieskoti",
  "/lv-lv/meklet",
  "/nl-nl/zoeken",
  "/nl-be/zoeken",
  "/nb-no/soek",
  "/pl-pl/szukaj",
  "/ro-ro/cautare",
  "/ru-ru/poisk",
  "/sk-sk/hladat",
  "/sv-se/sok",
  "/tr-tr/ara",
  "/en-gb/search",
  "/fr-ma/rechercher",
  "/fr-be/juridique/confidentialite",
  "/nl-be/juridisch/privacy",
  "/bg-bg/pravna-informacija/pravila-za-poveritelnost",
  "/cs-cz/pravni-zalezitosti/zasady-ochrany-osobnich-udaju",
  "/de-de/rechtliche-hinweise/datenschutz",
  "/da-dk/juridisk/beskyttelse-af-personlige-oplysninger",
  "/et-ee/juriidiline/privaatsus",
  "/es-es/legal/privacidad",
  "/fr-fr/juridique/confidentialite",
  "/it-it/note-legali/privacy",
  "/lt-lt/teisine-informacija/privatumas",
  "/lv-lv/juridiska-informacija/privatums",
  "/fr-ma/juridique/confidentialite",
  "/nl-nl/juridisch/privacy",
  "/nb-no/juridisk/personvern",
  "/pl-pl/informacje-prawne/prywatnosc",
  "/ro-ro/juridic/politica-de-confidentialitate",
  "/ru-ru/pravovaya-informatsiya/konfidentsialnost",
  "/sk-sk/pravne-informacie/pravidla-ochrany-sukromia",
  "/fi-fi/lakiasiat/tietosuoja",
  "/sv-se/juridiskt/integritet",
  "/en-gb/legal/privacy",
  "/tr-tr/yasal-kurallar/gizlilik-bildirimi",
  "/en/legal/privacy"
];
function isLinkForUnifiedWeb(link) {
  let url = link;
  if (link.startsWith("http")) {
    url = url.substring(url.indexOf("/", 8));
  }
  if (!url.startsWith("/")) url = `/${url}`;
  return pagesForNext.some((element) => url.startsWith(element));
}
var qualifiedLocales = {
  // Example
  // 'tr-TR': {
  //   availableBusinessUnits: [
  //     'FREIGHT',
  //     'LOGISTICS',
  //     'FREIGHT_FERRIES_AND_LOGISTICS',
  //     'PASSENGER',
  //   ],
  //   availablePages: [
  //     // tr-TR needs to be available on Legal pages, but legal is not a business unit so we need to select the pages by their ids,
  //     // we aren't using slugs here cause the slugs are different for each locale and can be changed by content editors...ids cannot be.
  //     '42CtkGBgc8mesEcgU2Eiqc', // /legal
  //     '1rt5VLtaq8aeUY80s8iGKM', // /legal/privacy
  //     '4Mrj2hrEJGeEGEckWkwgQW', // /legal/terms-of-use
  //     '3XDBO9XPReeYUcGcO4WI2Y', // /legal/cookies
  //     '4R3Ql0IrW0KK0w2wAg8Qa6', // /legal/privacy-customer-request
  //     '1ivrnzHaoKYII8MeQi0GGM', // /legal/cookies-decline
  //   ],
  //   hideLocale: false, // TOGGLE THIS TO QUICKLY TURN OFF LOCALE
  // },
};
var shouldLocaleBeInitialized = (locale, businessUnit, slugId) => {
  var _a;
  if (!qualifiedLocales[locale]) return true;
  if ((_a = qualifiedLocales[locale]) == null ? void 0 : _a.hideLocale) return false;
  return qualifiedLocales[locale].availableBusinessUnits.includes(businessUnit) || qualifiedLocales[locale].availablePages.includes(slugId);
};
var LocaleSelectorModal = ({
  localeSelectorHeader,
  routes,
  hide,
  isOpen,
  businessUnit,
  slugId
}) => {
  const modalRef = useRef(null);
  useClickOutside(modalRef, hide);
  const currentLocale = useLocale();
  return /* @__PURE__ */ jsxs(Wrapper, { isOpen, children: [
    /* @__PURE__ */ jsx(Overlay, {}),
    /* @__PURE__ */ jsx(StyledModal, { ref: modalRef, children: /* @__PURE__ */ jsxs(ModalWrapper, { children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, { children: [
        /* @__PURE__ */ jsxs(Header, { children: [
          /* @__PURE__ */ jsx(Text, { as: "h4", variant: "headline-4", children: localeSelectorHeader }),
          /* @__PURE__ */ jsx(
            Button2,
            {
              "data-e2e": "locale-modal-close",
              variant: "text",
              onClick: hide,
              icon: Close
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Divider, {})
      ] }),
      /* @__PURE__ */ jsx(Content, { children: locales.map((locale) => {
        const shouldLocaleRender = shouldLocaleBeInitialized(
          locale.locale,
          businessUnit,
          slugId
        );
        if (!shouldLocaleRender) return null;
        const country = locale.locale.split("-")[1];
        const FlagIcon = icons_exports[country ? country : "INT"];
        const currentRoute = (routes == null ? void 0 : routes[locale.locale]) || "";
        const localeExist = !!currentLocale;
        const localePath = `${locale.locale.startsWith("/") ? "" : "/"}${locale.locale.toLowerCase()}`;
        const path = localeExist && currentRoute.split("/").pop() !== "404" ? currentRoute : currentRoute.split("/")[0];
        return /* @__PURE__ */ jsxs(
          StyledNavLink,
          {
            "data-e2e": `locale-switch-${locale.locale}`,
            onClick: () => {
              var _a, _b;
              track({
                event: "countrySwitch",
                currentLocale,
                newLocale: locale.locale,
                languageOption: ((_b = (_a = locale.locale.split("-")) == null ? void 0 : _a[1]) == null ? void 0 : _b.toLowerCase()) || "EN"
              });
              hide();
            },
            href: `${localePath}/${path}`,
            children: [
              /* @__PURE__ */ jsx(Flag, { children: /* @__PURE__ */ jsx(FlagIcon, { title: locale.locale }) }),
              /* @__PURE__ */ jsx(Language, { children: locale.countryName })
            ]
          },
          locale.locale
        );
      }) })
    ] }) })
  ] });
};

// src/components/Search/Search.styles.tsx
var SearchBox = styled("div", {
  position: "relative",
  marginBottom: "$xs",
  i: {
    position: "absolute"
  },
  "::placeholder, ::-ms-input-placeholder": {
    color: "$overlay",
    opacity: 1
  }
});
var Icon = styled("i", {
  display: "flex",
  height: "100%",
  alignItems: "center",
  width: "40px",
  justifyContent: "center",
  svg: {
    fontSize: "$subtitle-1"
  },
  variants: {
    active: {
      true: {
        color: "$blue-primary",
        cursor: "pointer"
      }
    }
  }
});
var Input = styled("input", {
  fontFamily: "$DFDS",
  fontSize: "$label-medium",
  borderRadius: "0",
  height: "40px",
  paddingLeft: "40px",
  textAlign: "left",
  width: "100%",
  border: "1px solid $overlay"
});
var Hits = styled(BaseLink, {
  borderRadius: "0",
  variants: {
    type: {
      list: {
        borderBottomStyle: "solid",
        borderBottomWidth: "0.5px",
        paddingBlock: "$s"
      },
      cards: {
        backgroundColor: "$card",
        padding: "$s",
        marginBottom: "$xs",
        outline: "1.5px solid $card",
        transition: "outline-color 0.25s ease",
        "&:first-of-type": {
          marginTop: "$m"
        },
        "&:hover": {
          outline: "1.5px solid $group-blue-34",
          borderRadius: "1.5px"
        },
        span: {
          marginBottom: "$xs",
          fontSize: "$headline-4",
          lineHeight: "$headline-4"
        },
        ul: {
          color: "$text"
        }
      }
    }
  }
});
styled("div", {});
var Hit = styled("div", {
  display: "flex",
  flexDirection: "column",
  textAlign: "left",
  width: "100%",
  ul: {
    alignItems: "center",
    color: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    flexWrap: "wrap",
    fontWeight: "$light",
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  li: {
    margin: 0,
    userSelect: "none",
    "& + li:before": {
      content: "/",
      marginInline: "$xs"
    }
  },
  mark: {
    backgroundColor: "transparent",
    color: "$navy-medium"
  }
});
var CustomSearchBox = ({
  onChange,
  onReset,
  placeholder,
  value
}) => {
  const [inputActive, setInputActive] = useState(false);
  return /* @__PURE__ */ jsxs(SearchBox, { children: [
    /* @__PURE__ */ jsx(Icon, { active: inputActive, children: value !== "" ? /* @__PURE__ */ jsx(Close, { onClick: (event) => onReset(event) }) : /* @__PURE__ */ jsx(Search, {}) }),
    /* @__PURE__ */ jsx(
      Input,
      {
        autoFocus: true,
        autoComplete: "off",
        value,
        onChange,
        placeholder,
        onFocus: () => setInputActive(true),
        type: "search"
      }
    )
  ] });
};
var SearchBox2 = ({
  displayText,
  search
}) => {
  const { query, refine } = useSearchBox();
  const [value, setValue] = useState(query);
  function onInputChange(value2) {
    setValue(value2);
    refine(value2);
  }
  useEffect(() => {
    if (search) {
      setValue(search);
      refine(search);
    }
  }, [refine, search]);
  return /* @__PURE__ */ jsx(
    CustomSearchBox,
    {
      onChange: (event) => onInputChange(event.currentTarget.value),
      onReset: () => setValue(""),
      placeholder: displayText,
      value
    }
  );
};
var SearchHits = ({ variant }) => {
  const { hits } = useHits();
  const locale = useLocale();
  return /* @__PURE__ */ jsx(Fragment$1, { children: hits.map((hit) => {
    const breadcrumbs = hit.path.replace(`/${locale}/`, "").split("/");
    return /* @__PURE__ */ jsxs(
      Hits,
      {
        fullwidth: true,
        href: hit.path,
        variant: "flush",
        type: variant != null ? variant : "list",
        children: [
          /* @__PURE__ */ jsxs(Hit, { children: [
            /* @__PURE__ */ jsx(Highlight, { attribute: "title", hit }),
            /* @__PURE__ */ jsx("ul", { children: breadcrumbs.map((item) => /* @__PURE__ */ jsx("li", { children: item }, `${hit.objectID}-${item}`)) })
          ] }),
          variant === "cards" && /* @__PURE__ */ jsx(ArrowRight, {})
        ]
      },
      hit.objectID
    );
  }) });
};
var searchClient = algoliasearch(
  "Q661TEWRDR",
  "572dc62bc79f9fdef9ad71fb2996643d"
);
var SiteSearch = ({
  children,
  hitsPerPage,
  variant,
  search
}) => {
  var _a;
  const { discoverSection } = useNavigation({ keys: ["discoverSection"] });
  const locale = useLocale();
  return /* @__PURE__ */ jsxs(InstantSearch, { indexName: `crawler_${locale}`, searchClient, children: [
    /* @__PURE__ */ jsx(Configure, { hitsPerPage }),
    /* @__PURE__ */ jsx(SearchBox2, { displayText: (_a = discoverSection == null ? void 0 : discoverSection.search) != null ? _a : "", search }),
    /* @__PURE__ */ jsx(SearchHits, { variant }),
    children
  ] });
};
var Wrapper2 = styled("search", {
  background: "$background",
  boxShadow: "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 0 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  borderTop: `1px solid $group-blue-15`,
  left: 0,
  padding: "20px",
  position: "absolute",
  right: 0,
  top: "100%",
  zIndex: 100
});
var PromotionsContainer = styled(GridItem, {
  display: "none",
  "@xlUp": {
    display: "block",
    padding: "40px 0"
  }
});
var SiteSearchContainer = styled("div", {
  width: "100%",
  a: {
    width: "100%"
  },
  "@xlUp": {
    display: "flex",
    flexDirection: "column",
    padding: "40px 0"
  }
});
var Container2 = styled("div", {
  display: "flex",
  flexDirection: "column",
  marginBottom: "$s",
  h2: {
    fontWeight: "$bold"
  },
  "@lUp": {
    flexDirection: "row"
  }
});
var ImgContainer = styled("div", {
  width: "300px",
  flexShrink: 0
});
var ContentContainer = styled("div", {
  padding: "$m 0 0 0",
  display: "flex",
  flexDirection: "column",
  span: {
    paddingBottom: "$m"
  },
  "@lUp": {
    padding: "0 0 0 $m"
  }
});
var PromotionCardLink = styled("div", {
  marginTop: "$s",
  alignSelf: "start",
  "@xlUp": {
    alignSelf: "end"
  }
});
var ShowMoreStyled = styled("div", {
  marginTop: "15px",
  width: "100%",
  a: {
    justifyContent: "center",
    margin: "10px",
    textDecoration: "underline"
  }
});
var ShowMore = () => {
  const { discoverSection } = useNavigation({ keys: ["discoverSection"] });
  const { searchUrl, showResultsText } = discoverSection || {};
  const locale = useLocale();
  const { query } = useSearchBox();
  const getHref = (searchUrl2, searchQuery = "") => {
    const url = searchUrl2.startsWith("/") ? searchUrl2 : `/${locale}/${searchUrl2}`;
    const queryParam = searchQuery.length > 0 ? `?search=${searchQuery}` : "";
    return `${url}${queryParam}`;
  };
  return /* @__PURE__ */ jsx(ShowMoreStyled, { children: !!(searchUrl == null ? void 0 : searchUrl.url) && /* @__PURE__ */ jsx(
    BaseLink,
    {
      href: getHref(searchUrl.url, query),
      variant: "flush",
      children: /* @__PURE__ */ jsx("span", { children: showResultsText || "Show more" })
    },
    "show more"
  ) });
};
var RichTextWrapper = styled("div", {
  fontFamily: "$DFDS",
  whiteSpace: "break-spaces",
  "> :last-child": {
    marginBottom: "0"
  },
  "h2, h3, h4, h5, h6": {
    marginBottom: "$s"
  },
  "> p": {
    marginBottom: "$m",
    "@mUp": {
      marginBottom: "$l"
    }
  },
  ">p:has(iframe)": {
    display: "flex"
  },
  '> p a[class*="basic"], > p a[class*="flush"]': {
    display: "inline"
  },
  variants: {
    checklist: {
      true: {
        ul: {
          padding: 0,
          listStyle: "none"
        },
        li: {
          display: "flex",
          "&:before": {
            content: 'url("data:image/svg+xml;base64,CiAgICA8c3ZnCiAgICAgIHdpZHRoPSIyNCIKICAgICAgaGVpZ2h0PSIyNCIKICAgICAgdmlld0JveD0iMCAwIDI0IDI0IgogICAgICBmaWxsPSJub25lIgogICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICA+CiAgICAgIDxwYXRoCiAgICAgICAgZmlsbFJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgY2xpcFJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTE4LjU4NTggNi41ODU2OUwyMCA3Ljk5OTkxTDkuNjU2ODUgMTguMzEzNkw4LjI0MjY0IDE2Ljg5OTRMMTguNTg1OCA2LjU4NTY5Wk01LjQxNDIxIDExLjI0MjVMOS42NTY4NSAxNS40ODUyTDguMjQyNjQgMTYuODk5NEw0IDEyLjY1NjhMNS40MTQyMSAxMS4yNDI1WiIKICAgICAgICBmaWxsPSIjMkNBOTY4IgogICAgICAvPgogICAgPC9zdmc+Cg==")'
          },
          p: {
            margin: "0 0 $s $s"
          }
        }
      }
    }
  }
});
var Bold = styled("strong", {
  fontWeight: "$bold"
});
var Ul = styled("ul", {
  marginBottom: "$l",
  listStyle: "disc",
  p: {
    margin: 0
  }
});
var Ol = styled("ol", {
  marginBottom: "$l",
  listStyleType: "decimal",
  "li::marker": {
    fontSize: "$body-1"
  },
  p: {
    marginBottom: "$xs"
  }
});
var Table = styled("table", {
  overflowX: "auto",
  maxWidth: "100%",
  width: "100%",
  marginBottom: "$l",
  color: "inherit",
  borderCollapse: "collapse"
});
var TableBody = styled("tbody", {
  width: "100%",
  p: {
    margin: 0
  }
});
var TableRow = styled("tr", {
  "&:nth-of-type(even)": {
    backgroundColor: "$card"
  }
});
var TableHead = styled("th", {
  padding: "$xxs $xs",
  textAlign: "left",
  lineHeight: "20px",
  "> p": {
    fontSize: "$body-1",
    fontWeight: "$bold"
  }
});
var TableCell = styled("td", {
  padding: "$xxs $xs",
  p: {
    fontSize: "$body-1",
    margin: 0
  }
});
var BlockQuote = styled("blockquote", {
  fontFamily: "$DFDS",
  marginBottom: "$l",
  paddingLeft: "$s",
  border: 0,
  borderLeft: "solid",
  borderColor: "$group-blue-15",
  borderWidth: "$l",
  p: {
    fontStyle: "italic",
    fontSize: "$subtitle-1",
    fontWeight: "$regular",
    lineHeight: "$headline-4",
    marginBottom: "$s"
  }
});
var AssetLinkWrapper = styled("figure", {
  alignItems: "center",
  marginBottom: "$l"
});
var ImageCaption = styled(
  "figcaption",
  {
    fontFamily: "$dfds",
    fontSize: "$label-small",
    lineHeight: "$s",
    fontWeight: "$regular",
    textAlign: "left",
    color: "$group-blue-secondary",
    marginTop: "$xs"
  }
);
var VideoWrapper = styled("iframe", {
  width: "100%",
  aspectRatio: "16 / 9",
  border: "none"
});
var LinkStyling = styled("u", {
  color: "$blue-primary",
  fontWeight: "$regular"
});
function renderSanitizedRichText(richText, paragraphVariant, hideRichElements) {
  const rendered = documentToReactComponents(
    richText.json,
    renderOptions(richText, paragraphVariant, hideRichElements)
  );
  return sanitizeTextNodes(rendered);
}
function renderOptions(richText, paragraphVariant, hideRichElements) {
  var _a, _b, _c, _d, _e, _f;
  const assetMap = /* @__PURE__ */ new Map();
  const entryMap = /* @__PURE__ */ new Map();
  if ((_b = (_a = richText == null ? void 0 : richText.links) == null ? void 0 : _a.assets) == null ? void 0 : _b.block)
    for (const asset of richText.links.assets.block) {
      assetMap.set(asset == null ? void 0 : asset.sys.id, asset);
    }
  if ((_d = (_c = richText == null ? void 0 : richText.links) == null ? void 0 : _c.entries) == null ? void 0 : _d.block)
    for (const entry of richText.links.entries.block) {
      entryMap.set(entry == null ? void 0 : entry.sys.id, entry);
    }
  if ((_f = (_e = richText == null ? void 0 : richText.links) == null ? void 0 : _e.entries) == null ? void 0 : _f.inline)
    for (const entry of richText.links.entries.inline) {
      entryMap.set(entry == null ? void 0 : entry.sys.id, entry);
    }
  return {
    renderMark: createMarkRenderer(),
    renderNode: {
      [BLOCKS.HEADING_1]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h1", variant: "headline-1", children }),
      [BLOCKS.HEADING_2]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h2", variant: "headline-2", children }),
      [BLOCKS.HEADING_3]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h3", variant: "headline-3", children }),
      [BLOCKS.HEADING_4]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h4", variant: "headline-4", children }),
      [BLOCKS.HEADING_5]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h5", variant: "headline-5", children }),
      [BLOCKS.HEADING_6]: (_, children) => /* @__PURE__ */ jsx(Text, { as: "h6", variant: "headline-6", children }),
      [BLOCKS.PARAGRAPH]: (_, children) => /* @__PURE__ */ jsx(Text, { variant: paragraphVariant != null ? paragraphVariant : "body-1", children }),
      [BLOCKS.HR]: () => /* @__PURE__ */ jsx(Divider, { css: { marginBlock: "$l" } }),
      [BLOCKS.UL_LIST]: (_, children) => /* @__PURE__ */ jsx(Ul, { children }),
      [BLOCKS.OL_LIST]: (_, children) => /* @__PURE__ */ jsx(Ol, { children }),
      [BLOCKS.TABLE]: (_, children) => /* @__PURE__ */ jsx(Table, { children: /* @__PURE__ */ jsx(TableBody, { children }) }),
      [BLOCKS.TABLE_HEADER_CELL]: (_, children) => /* @__PURE__ */ jsx(TableHead, { children }),
      [BLOCKS.TABLE_ROW]: (_, children) => /* @__PURE__ */ jsx(TableRow, { children }),
      [BLOCKS.TABLE_CELL]: (_, children) => /* @__PURE__ */ jsx(TableCell, { children }),
      [BLOCKS.QUOTE]: (_, children) => /* @__PURE__ */ jsx(BlockQuote, { children }),
      [INLINES.HYPERLINK]: (node, children) => renderHyperlink(node, children),
      [INLINES.EMBEDDED_ENTRY]: (node) => renderEmbeddedEntry(node, entryMap),
      [BLOCKS.EMBEDDED_ASSET]: (node) => renderEmbeddedAsset(node, assetMap, hideRichElements)
    }
  };
}
function createMarkRenderer() {
  return {
    [MARKS.BOLD]: (text) => /* @__PURE__ */ jsx(Bold, { children: text }),
    [MARKS.ITALIC]: (text) => /* @__PURE__ */ jsx("i", { children: text }),
    [MARKS.UNDERLINE]: (text) => /* @__PURE__ */ jsx("u", { children: text })
  };
}
function renderHyperlink(node, children) {
  const { uri } = node.data;
  const videoIdRegex = /(?:\?v=|\/watch\?v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = uri.match(videoIdRegex);
  const videoId = match ? match[1] : null;
  return videoId ? /* @__PURE__ */ jsx(
    VideoWrapper,
    {
      title: `https://youtube.com/embed/${videoId}`,
      src: `https://youtube.com/embed/${videoId}`,
      allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true
    }
  ) : /* @__PURE__ */ jsx(BaseLink, { variant: "flush", href: uri, target: "_blank", children: /* @__PURE__ */ jsx(LinkStyling, { children }) });
}
function renderEmbeddedEntry(node, entryMap) {
  var _a, _b;
  const entry = entryMap.get(node.data.target.sys.id);
  if ((entry == null ? void 0 : entry.__typename) === "Link") {
    return /* @__PURE__ */ jsxs(
      Link,
      {
        link: entry,
        variant: entry == null ? void 0 : entry.linkType,
        target: ((_a = entry == null ? void 0 : entry.url) == null ? void 0 : _a.urlType) === "External" ? "_blank" : "_self",
        children: [
          ((_b = entry.icon) == null ? void 0 : _b.url) && entry.icon.title && entry.icon.width && entry.icon.height && /* @__PURE__ */ jsx(IconWrapper, { children: /* @__PURE__ */ jsx(
            ImageWithContext,
            {
              src: entry.icon.url,
              alt: entry.icon.title,
              width: entry.icon.width,
              height: entry.icon.height
            }
          ) }),
          entry.displayText
        ]
      },
      entry == null ? void 0 : entry.sys.id
    );
  }
}
function renderEmbeddedAsset(node, assetMap, hideRichElements) {
  if (hideRichElements) return null;
  const asset = assetMap.get(node.data.target.sys.id);
  if (!(asset == null ? void 0 : asset.url)) return null;
  const isImage = /\.(png|jpe?g|svg|tif|webp|jfif|gif)/i.test(asset.url) ? /\.(png|jpe?g|svg|tif|webp|jfif|gif)/i.test(asset == null ? void 0 : asset.url) : false;
  return /* @__PURE__ */ jsx(AssetLinkWrapper, { children: isImage && asset.width && asset.height && asset.title ? /* @__PURE__ */ jsxs("figure", { children: [
    /* @__PURE__ */ jsx(
      ImageWithContext,
      {
        src: asset.url,
        width: asset.width,
        height: asset.height,
        alt: asset.title
      }
    ),
    /* @__PURE__ */ jsx(ImageCaption, { children: asset.description })
  ] }) : /* @__PURE__ */ jsx(
    BaseLink,
    {
      variant: "flush",
      target: "_blank",
      href: asset.url,
      download: asset.fileName,
      children: /* @__PURE__ */ jsxs("span", { children: [
        asset.title,
        " ",
        /* @__PURE__ */ jsx(SvgDocument, {})
      ] })
    }
  ) }, asset.sys.id);
}
function sanitizeTextNodes(node) {
  var _a;
  const UNWANTED_SPACES_REGEX = /\u00A0|\u202F|\u2002|\u2003|\u2009|\u200B|\u200C|\u200D|\uFEFF/g;
  if (typeof node === "string") {
    return node.replace(UNWANTED_SPACES_REGEX, " ");
  }
  if (Array.isArray(node)) {
    return node.map(sanitizeTextNodes);
  }
  if (typeof node === "object" && node !== null && "props" in node && ((_a = node.props) == null ? void 0 : _a.children)) {
    return __spreadProps(__spreadValues({}, node), {
      props: __spreadProps(__spreadValues({}, node.props), {
        children: sanitizeTextNodes(node.props.children)
      })
    });
  }
  return node;
}
var RichTextRenderer = (_a) => {
  var _b = _a, {
    richText,
    paragraphVariant,
    hideRichElements
  } = _b, rest = __objRest(_b, [
    "richText",
    "paragraphVariant",
    "hideRichElements"
  ]);
  return /* @__PURE__ */ jsx(RichTextWrapper, __spreadProps(__spreadValues({}, rest), { children: renderSanitizedRichText(richText, paragraphVariant, hideRichElements) }));
};
var SiteSearchPromotions = () => {
  const { promotionsCollection: promotions } = useNavigation({
    keys: ["promotionsCollection"]
  });
  return /* @__PURE__ */ jsx(Fragment$1, { children: promotions == null ? void 0 : promotions.items.map((promotion) => {
    var _a, _b;
    const {
      primaryText,
      secondaryText,
      richText,
      ctasCollection,
      assetsCollection
    } = promotion || {};
    const { url, title, width, height } = (assetsCollection == null ? void 0 : assetsCollection.items[0]) || {};
    return /* @__PURE__ */ jsxs(Container2, { children: [
      /* @__PURE__ */ jsx(ImgContainer, { children: url && title && width && height && /* @__PURE__ */ jsx(ImageWithContext, { src: url, alt: title, width, height }) }),
      /* @__PURE__ */ jsxs(ContentContainer, { children: [
        !!primaryText && /* @__PURE__ */ jsx(Text, { variant: "headline-3", children: primaryText }),
        richText ? /* @__PURE__ */ jsx(
          RichTextRenderer,
          {
            paragraphVariant: "body-1-light",
            richText
          }
        ) : !!secondaryText && /* @__PURE__ */ jsx(Text, { variant: "body-1-light", children: secondaryText }),
        !!ctasCollection && /* @__PURE__ */ jsx(PromotionCardLink, { children: /* @__PURE__ */ jsx(Link, { link: ctasCollection == null ? void 0 : ctasCollection.items[0], variant: "flush", children: (_b = ctasCollection == null ? void 0 : ctasCollection.items[0]) == null ? void 0 : _b.displayText }) })
      ] })
    ] }, (_a = promotion == null ? void 0 : promotion.sys) == null ? void 0 : _a.id);
  }) });
};
var SearchModal = () => {
  return /* @__PURE__ */ jsx(Wrapper2, { children: /* @__PURE__ */ jsx(Container, { children: /* @__PURE__ */ jsxs(Grid, { children: [
    /* @__PURE__ */ jsx(PromotionsContainer, { large: 7, children: /* @__PURE__ */ jsx(SiteSearchPromotions, {}) }),
    /* @__PURE__ */ jsx(GridItem, { large: 5, children: /* @__PURE__ */ jsx(SiteSearchContainer, { children: /* @__PURE__ */ jsx(SiteSearch, { hitsPerPage: 5, children: /* @__PURE__ */ jsx(ShowMore, {}) }) }) })
  ] }) }) });
};
function MobileDrawer({
  forceMobile,
  isMenuOpen,
  onClick,
  navigations
}) {
  const { discoverSection } = useNavigation();
  const contactPagesSection = discoverSection == null ? void 0 : discoverSection.contactPagesSection;
  const customerPortalsSection = discoverSection == null ? void 0 : discoverSection.customerPortalsSection;
  useDisableHtmlScroll(isMenuOpen);
  const sections = [contactPagesSection, customerPortalsSection].filter(
    (section) => section
  );
  return /* @__PURE__ */ jsxs(HideOnDesktop, { forceShow: forceMobile, children: [
    /* @__PURE__ */ jsx(
      StyledIconButton,
      {
        onClick,
        icon: isMenuOpen ? Close : Menu,
        "aria-label": isMenuOpen ? "Close Menu" : "Open Menu",
        "data-e2e": isMenuOpen ? "close-mobile-menu" : "open-mobile-menu",
        variant: "navtab"
      }
    ),
    isMenuOpen && /* @__PURE__ */ jsxs(StyledDrawer, { children: [
      sections.map((section) => {
        var _a;
        return /* @__PURE__ */ jsx(Accordion, { collapsible: true, children: /* @__PURE__ */ jsxs(AccordionItem, { children: [
          /* @__PURE__ */ jsxs(
            StyledAccordionButton,
            {
              onClick: (e) => {
                if (e.currentTarget.dataset.state !== "open") {
                  trackAccordionClick(
                    section == null ? void 0 : section.displayText,
                    section == null ? void 0 : section.sys.id
                  );
                }
              },
              children: [
                /* @__PURE__ */ jsx(Text, { as: "p", variant: "label-medium-bold", children: section == null ? void 0 : section.displayText }),
                /* @__PURE__ */ jsx(ChevronDown, { "aria-hidden": true })
              ]
            }
          ),
          /* @__PURE__ */ jsx(StyledAccordionPanel, { children: (_a = section == null ? void 0 : section.sectionItemsCollection) == null ? void 0 : _a.items.map((item) => {
            var _a2;
            return /* @__PURE__ */ jsx(
              MenuListButton,
              {
                item
              },
              ((_a2 = item == null ? void 0 : item.sys) == null ? void 0 : _a2.id) || (item == null ? void 0 : item.entryTitle)
            );
          }) })
        ] }) }, section == null ? void 0 : section.sys.id);
      }),
      /* @__PURE__ */ jsx(GlobalNavigationItems, { sections: navigations == null ? void 0 : navigations.items })
    ] })
  ] });
}
function hasProperty(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}
var RightSectionChildren = forwardRef((_a, ref) => {
  var _b = _a, { forceMobile, children } = _b, rest = __objRest(_b, ["forceMobile", "children"]);
  return /* @__PURE__ */ jsx(StyledSearchAndHelpSection, __spreadProps(__spreadValues({}, rest), { ref, forceMobile, children: Children.toArray(children).map((child, index) => /* @__PURE__ */ jsx(
    Fragment,
    {
      children: child
    },
    isElement(child) && hasProperty(child, "key") ? `nav-right-wrapper-${child.key}` : `nav-right-wrapper-${index}`
  )) }));
});
RightSectionChildren.displayName = "RightSectionChildren";
function isElement(element) {
  return !!element && typeof element === "object" && hasProperty(element, "props");
}
function RightSection({
  children,
  navigations,
  forceMobile,
  locale,
  localizedRoutes,
  slugId,
  businessUnit
}) {
  var _a, _b, _c, _d;
  const {
    search,
    contactPagesSection,
    customerPortalsSection,
    localeSelectorHeader
  } = ((_a = useNavigation()) == null ? void 0 : _a.discoverSection) || {};
  const navIndex = {
    menuDrawer: 1,
    search: 2,
    contact: 3,
    portals: 4,
    localeSelectorHeader: 5
  };
  const [showNavItem, setShowNavItem] = useState(null);
  useDisableHtmlScroll(showNavItem === navIndex.localeSelectorHeader);
  const closeNavItem = useCallback(() => {
    setShowNavItem(null);
  }, [setShowNavItem]);
  const rightSideRef = useRef(null);
  useClickOutside(rightSideRef, closeNavItem);
  useCallbackOnRouteChange(closeNavItem);
  const handleNavItemClick = useCallback(
    (index) => {
      setShowNavItem((currentIndex) => currentIndex === index ? null : index);
    },
    [setShowNavItem]
  );
  const FlagIcon = useMemo(() => {
    var _a2;
    const country = (_a2 = locale.split("-")[1]) == null ? void 0 : _a2.toUpperCase();
    return icons_exports[country ? country : "INT"];
  }, [locale]);
  const childrenWithOnClick = Children.toArray(children).map((child, index) => {
    if (!child) return child;
    if (!isElement(child)) {
      return /* @__PURE__ */ jsx(
        "button",
        {
          onClick: closeNavItem,
          onKeyDown: (e) => e.key === "Enter" && closeNavItem(),
          style: { all: "unset", cursor: "pointer" },
          children: child
        },
        `nav-child-${index}`
      );
    }
    const props = {
      key: `nav-child-${index}`,
      onClick: hasProperty(child.props, "onClick") ? (...args) => {
        closeNavItem();
        return child.props.onClick(...args);
      } : () => {
        closeNavItem();
      }
    };
    return cloneElement(child, props);
  });
  return /* @__PURE__ */ jsxs(
    RightSectionChildren,
    {
      "data-e2e": "contextual-navigation-right-section",
      forceMobile,
      ref: rightSideRef,
      children: [
        /* @__PURE__ */ jsx(
          MobileDrawer,
          {
            onClick: () => setShowNavItem(
              (currentIndex) => currentIndex === navIndex.menuDrawer ? null : navIndex.menuDrawer
            ),
            isMenuOpen: showNavItem === navIndex.menuDrawer,
            navigations,
            forceMobile
          }
        ),
        /* @__PURE__ */ jsx(HideOnMobile, { forceHide: forceMobile, children: /* @__PURE__ */ jsxs(StyledChildrenAndLocalePickerSection, { children: [
          /* @__PURE__ */ jsx(
            StyledIconButton,
            {
              "aria-label": search || "Search",
              onClick: () => {
                trackContextualMenuClick(search || "Search", "search");
                setShowNavItem(
                  (currentIndex) => currentIndex === navIndex.search ? null : navIndex.search
                );
              },
              "data-e2e": "search",
              variant: "navtab",
              children: showNavItem === navIndex.search ? /* @__PURE__ */ jsx(Close, {}) : /* @__PURE__ */ jsx(Search, {})
            }
          ),
          !!contactPagesSection && /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs(StyledContactAndPortals, { children: [
            /* @__PURE__ */ jsx(
              StyledIconButton,
              {
                "aria-label": contactPagesSection.displayText || "Support",
                onClick: () => {
                  trackContextualMenuClick(
                    contactPagesSection.displayText,
                    contactPagesSection.sys.id
                  );
                  handleNavItemClick(navIndex.contact);
                },
                "data-e2e": "support",
                variant: "navtab",
                children: /* @__PURE__ */ jsx(SupportContact, {})
              }
            ),
            /* @__PURE__ */ jsx(
              LinkDropdown,
              {
                alignRight: true,
                open: showNavItem === navIndex.contact,
                items: (_b = contactPagesSection.sectionItemsCollection) == null ? void 0 : _b.items
              }
            )
          ] }) }),
          !!customerPortalsSection && /* @__PURE__ */ jsxs(StyledContactAndPortals, { children: [
            /* @__PURE__ */ jsx(
              StyledIconButton,
              {
                "aria-label": customerPortalsSection.displayText || "Customer portals",
                onClick: () => {
                  trackContextualMenuClick(
                    customerPortalsSection.displayText,
                    customerPortalsSection.sys.id
                  );
                  handleNavItemClick(navIndex.portals);
                },
                "data-e2e": "customer-portals",
                variant: "navtab",
                children: /* @__PURE__ */ jsx(Account, {})
              }
            ),
            /* @__PURE__ */ jsx(
              LinkDropdown,
              {
                alignRight: true,
                open: showNavItem === navIndex.portals,
                items: (_c = customerPortalsSection.sectionItemsCollection) == null ? void 0 : _c.items
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsxs(StyledChildrenAndLocalePickerSection, { children: [
          childrenWithOnClick,
          !!localeSelectorHeader && /* @__PURE__ */ jsx(
            StyledIconButton,
            {
              "aria-label": (localeSelectorHeader == null ? void 0 : localeSelectorHeader.key) || "Website and language",
              onClick: () => {
                track({
                  event: "buttonClick",
                  eventAction: "locale selector clicked",
                  clickedElementText: "top-nav-locale-selector"
                });
                handleNavItemClick(navIndex.localeSelectorHeader);
              },
              "data-e2e": "top-nav-locale-selector",
              variant: "navtab",
              children: /* @__PURE__ */ jsxs(Flag, { children: [
                /* @__PURE__ */ jsx(FlagIcon, { title: locale }),
                " "
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsx(HideOnDesktop, { forceShow: forceMobile, children: /* @__PURE__ */ jsxs(StyledChildrenAndLocalePickerSection, { children: [
          /* @__PURE__ */ jsx(
            StyledIconButton,
            {
              onClick: () => {
                trackContextualMenuClick(search || "Search", "search");
                setShowNavItem(
                  (currentIndex) => currentIndex === navIndex.search ? null : navIndex.search
                );
              },
              icon: showNavItem === navIndex.search ? Close : Search,
              "aria-label": showNavItem === navIndex.search ? "Close Search" : "Open Search",
              "data-e2e": showNavItem === navIndex.search ? "close-mobile-search" : "open-mobile-search",
              variant: "navtab"
            }
          ),
          !!customerPortalsSection && /* @__PURE__ */ jsxs(StyledContactAndPortals, { children: [
            /* @__PURE__ */ jsx(
              StyledIconButton,
              {
                onClick: () => {
                  trackContextualMenuClick(
                    customerPortalsSection.displayText,
                    customerPortalsSection.sys.id
                  );
                  setShowNavItem(
                    (currentIndex) => currentIndex === navIndex.portals ? null : navIndex.portals
                  );
                },
                icon: Account,
                "aria-label": customerPortalsSection.displayText || "Customer Portals",
                "data-e2e": showNavItem === navIndex.portals ? "close-mobile-portals" : "open-mobile-portals",
                variant: "navtab"
              }
            ),
            /* @__PURE__ */ jsx(
              LinkDropdown,
              {
                alignRight: true,
                open: showNavItem === navIndex.portals,
                items: (_d = customerPortalsSection.sectionItemsCollection) == null ? void 0 : _d.items
              }
            )
          ] })
        ] }) }),
        showNavItem === navIndex.search && /* @__PURE__ */ jsx(SearchModal, {}),
        showNavItem === navIndex.localeSelectorHeader && /* @__PURE__ */ jsx(
          LocaleSelectorModal,
          {
            isOpen: showNavItem === navIndex.localeSelectorHeader,
            businessUnit,
            slugId,
            localeSelectorHeader: (localeSelectorHeader == null ? void 0 : localeSelectorHeader.key) || "Website and language",
            routes: localizedRoutes,
            hide: () => setShowNavItem(null)
          }
        )
      ]
    }
  );
}
function copyAndSortNavigation(items) {
  return [...items || []].sort(
    (a, b) => (a == null ? void 0 : a.order) - (b == null ? void 0 : b.order)
  );
}
function GlobalNavigationItems({
  sections,
  isDesktop
}) {
  const businessUnit = useBusinessUnit();
  if (!sections || !businessUnit) return /* @__PURE__ */ jsx(Fragment$1, {});
  const sortedSections = copyAndSortNavigation(sections);
  return /* @__PURE__ */ jsx(Fragment$1, { children: sortedSections.map((item) => {
    if (!item) return /* @__PURE__ */ jsx(Fragment$1, {});
    const sharedProps = {
      onClick: () => {
        trackGlobalMenuClick(item.displayText, item.sys.id);
        setBusinessUnit(item.businessArea);
      },
      selected: item.businessArea === businessUnit,
      variant: "navtab",
      key: `global-${item.sys.id || item.displayText}-${isDesktop}`
    };
    if (!isDesktop) {
      return /* @__PURE__ */ createElement(MenuListButton, __spreadProps(__spreadValues({ item }, sharedProps), { key: item.sys.id }));
    }
    const link = __spreadValues({
      displayText: item.displayText
    }, item.landingPage || {});
    return /* @__PURE__ */ createElement(Link, __spreadProps(__spreadValues({ link }, sharedProps), { key: link.sys.id }));
  }) });
}
var TopNavigation = ({
  navigations,
  businessUnit,
  children,
  locale,
  forceMobileNavigationView,
  localizedRoutes,
  slugId
}) => {
  var _a, _b, _c, _d;
  setNavigations(navigations);
  setBusinessUnit(businessUnit);
  const navigationRef = useRef(null);
  const [isMobile] = useResponsiveNav(navigationRef);
  const forceMobileLayout = forceMobileNavigationView || isMobile;
  const logoURL = ((_d = (_c = (_b = (_a = navigations == null ? void 0 : navigations.items) == null ? void 0 : _a[2]) == null ? void 0 : _b.siteSettings) == null ? void 0 : _c.logo) == null ? void 0 : _d.url) || void 0;
  return /* @__PURE__ */ jsxs("header", { children: [
    /* @__PURE__ */ jsx(
      DesktopOnlyGlobalNavigation,
      {
        "data-e2e": "global-navigation-desktop",
        forceHide: forceMobileLayout,
        children: /* @__PURE__ */ jsx(GlobalNavigationItems, { isDesktop: true, sections: navigations == null ? void 0 : navigations.items })
      }
    ),
    /* @__PURE__ */ jsx(ParentWithRelativePosition, { children: /* @__PURE__ */ jsxs(StyledContextualNavigation, { ref: navigationRef, children: [
      /* @__PURE__ */ jsx(LeftSection, { children: logoURL && /* @__PURE__ */ jsx(Logo, { logoUrl: logoURL, height: "28px", width: "81px" }) }),
      /* @__PURE__ */ jsx(DesktopContextualNavigationItems, { forceHide: forceMobileLayout }),
      /* @__PURE__ */ jsx(
        RightSection,
        {
          navigations,
          forceMobile: forceMobileLayout,
          locale,
          slugId,
          localizedRoutes,
          businessUnit,
          children
        }
      )
    ] }) })
  ] });
};
var localeMap = {};
var lowercasedLocaleSet = /* @__PURE__ */ new Set();
locales.forEach((locale) => {
  localeMap[locale.locale] = "";
  lowercasedLocaleSet.add(locale.locale.toLowerCase());
});
async function getLocaleSwitcherUrls(contentfulClient, locale, slug) {
  if (!slug) return { urlsWithFallbacks: localeMap, exactMatchUrls: {} };
  const fallbackSlug = slug.split("/").slice(0, 1).join("/");
  const [availableRoutes, localizedRoutes] = await Promise.all([
    getUrls(contentfulClient, locale, slug),
    !!fallbackSlug && fallbackSlug !== slug && getUrls(contentfulClient, locale, fallbackSlug)
  ]);
  for (const locale2 of Object.keys(availableRoutes)) {
    const [firstChunk, secondChunk] = availableRoutes[locale2].split("/");
    if (lowercasedLocaleSet.has(
      (firstChunk == null ? void 0 : firstChunk.toLowerCase()) || (secondChunk == null ? void 0 : secondChunk.toLowerCase())
    )) {
      delete availableRoutes[locale2];
    }
  }
  return {
    exactMatchUrls: availableRoutes,
    urlsWithFallbacks: __spreadValues(__spreadValues(__spreadValues({}, localeMap), localizedRoutes), availableRoutes)
  };
}

// src/utils/businessUnitLogic.ts
var BUSINESS_MAPPINGS = {
  GROUP: {
    businessArea: "ABOUT",
    businessType: "B2X",
    businessDivision: void 0
  },
  OTHER: {
    businessArea: "ABOUT",
    businessType: "B2X",
    businessDivision: void 0
  },
  ABOUT: {
    businessArea: "ABOUT",
    businessType: "B2X",
    businessDivision: void 0
  },
  LOGISTICS: {
    // seems to be deprecated?
    businessArea: "FREIGHT_FERRIES_AND_LOGISTICS",
    businessType: "B2B",
    businessDivision: "Logistics"
  },
  FREIGHT: {
    // seems to be deprecated?
    businessArea: "FREIGHT_FERRIES_AND_LOGISTICS",
    businessType: "B2B",
    businessDivision: "Freight Ferry"
  },
  FREIGHT_FERRIES_AND_LOGISTICS: {
    businessArea: "FREIGHT_FERRIES_AND_LOGISTICS",
    businessType: "B2B",
    businessDivision: void 0
  },
  PASSENGER: {
    businessArea: "PASSENGER",
    businessType: "B2C",
    businessDivision: "Passenger"
  }
};
function getBusinessMapping(businessUnit) {
  const buKey = businessUnit == null ? void 0 : businessUnit.toUpperCase().trim();
  if (!buKey) {
    return BUSINESS_MAPPINGS.PASSENGER;
  }
  return BUSINESS_MAPPINGS[buKey] || BUSINESS_MAPPINGS.PASSENGER;
}
function mapBusinessUnit(businessUnit) {
  return getBusinessMapping(businessUnit).businessArea;
}

export { BaseLink, FooterNavigation, Link, RichTextRenderer, SiteSearch, Themes, TopNavigation, currentBusinessUnitStore, currentLocaleStore, getBusinessMapping, getLocaleSwitcherUrls, getThemeColors, isDarkenTheme, isDefinedTheme, isLinkForUnifiedWeb, mapBusinessUnit, setBusinessUnit, useBusinessUnit, useConstructHrefWithLocale, useCustomImageComponent, useCustomLinkComponent, useLocale, useSetLocale };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map